<template>
  <div>
    <label class="text-secondary">{{ label_text }}</label>

    <ValidationProvider
      :rules="rules"
      v-slot="{ errors, failed }"
    >
      <b-form-input
        v-model="value"
        :class="failed ? 'error-input ' + classes : classes"
        :name="input_name"
      ></b-form-input>

      <span class="form-error">{{ errors[0] }}</span>
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  props: {
    label_text: String,
    rules: String,
    input_name: String,
    classes: String,
  },

  data() {
    return {
      value: ''
    }
  }
}
</script>

<style scoped>
  .form-error {
    color: #D9534F;
    padding: 5px;
  }
  .error-input {
    border:1px solid #D9534F
  }
</style>
